<template>
  <div>
       <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
      <v-row dense>
        <v-col>
          <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
          </v-card>
           <p></p>
              <v-card>
              <v-card-text v-if="e1==1">
                  <p class="text-h5 text--primary">เงื่อนไขและข้อกำหนด</p>
                  <div class="text--primary">
                   1.คุณจะต้องพร้อมปฏิบัติงานตลอดเวลาทำงาน ช่วงเวลาปฏิบัติงาน<br>
                   2.คุณจะต้องพร้อมประชุม หรือติดต่องานภายในเวลา 30 นาทีเมื่อมีการร้องขอ<br>
                   3.คุณจะต้องลงบันทึกเวลาปฏิบัติงานผ่านระบบ LINE Official Account - HRM-Betask<br>
                   4.หากคุณไม่ลงบันทึกเวลาปฏิบัติงานตามช่วงเวลาทำงานของคุณ ระบบจะบันทึกว่าเป็น "ขาดงาน" โดยอัตโนมัติ<br>
                   5.ขอความร่วมมือให้คุณหลีกเลี่ยงการสัมผัสใกล้ชิดกับบุคคลที่มีความเสี่ยงต่อโรค Covid-19 หรือเดือนทางในพื้นที่เสี่ยง<br>
                   6.หากมีการตรวจสอบพว่าคุณไม่ปฏิบัติตามเงื่อนไข ข้อตกลงดังกล่าว ทางบริษัท จะมีการพิจารณาบทลงโทษและมีผลต่อการพิจารณาประเมินผลงานของคุณ<br>
                  </div>
                </v-card-text>
                <center>
                  <v-btn color="blue" block dark large  @click="accept()" v-if="e1==1"> ฉันเข้าใจและยอมเงื่อนไข </v-btn>
                 </center>
              </v-card>
                <template>
                 <v-card-text  v-if="e1==2" >
                  <v-card-text>
                    <v-card class="mx-auto my-2 text-left" elevation="12">
                      <v-card-text>
                        <div class="text--primary">
                          ท่านที่ยินยอมให้ข้อมูลประวัติส่วนตัวแก่หน่วยงานศูนย์ช่วยเหลือโรงพยาบาลที่ท่านบริษัทติดต่อหรือไม่ข้อมูลการตรวจผลโควิดล่าสุด
                        </div>
                      </v-card-text>
                      <v-card-text>
                        <center>
                          <v-chip-group
                            active-class="deep-purple accent-4 white--text text-center"
                            column
                            v-model="selection"
                            style="margin-left: 25%"
                          >
                            <v-chip v-on:click="form.formSaveRisk5 = 1">ยินยอม</v-chip>

                            <v-chip v-on:click="form.formSaveRisk5 = 0"
                              >ไม่ยินยอม</v-chip
                            >
                          </v-chip-group>
                        </center>
                      </v-card-text>
                    </v-card>
                    <br>

                    <v-card class="mx-auto my-2 text-left" elevation="12">
                      <v-card-text>
                        <div class="text--primary">
                          ข้อมูลการตรวจผลโควิดล่าสุด
                        </div>
                        <center>
                      <v-row style="height: 50px">
                        <v-col cols="12" >
                      <v-file-input
                        v-model="files"
                        @change="fileupload"
                        placeholder="แนบไฟล์ผลตรวจ RT-PCR (LAB-TEST)"
                        required
                      ></v-file-input>
                      </v-col>
                      </v-row>
                        </center>
                        <br>
                        <br>
                      </v-card-text>
                    </v-card>
                    <br>

                    <v-card class="mx-auto my-2 text-left" elevation="12">
                      <v-card-text>
                        <div class="text--primary">
                          ท่านอาศัยร่วมกันกับที่อยู่ปัจจุบันกี่คน
                        </div>
                        <center>
                      <v-row style="height: 50px">
                        <v-col cols="12" >
                      <v-text-field
                        v-model="covidPeopleNum"
                        placeholder="กรอกจำนวน"
                        :rules="numberRules"
                        required
                      ></v-text-field>
                      </v-col>
                      </v-row>
                        </center>
                        <br>
                        <br>
                      </v-card-text>
                    </v-card>
                    <br>

                    <v-card class="mx-auto my-2 text-left" elevation="12">
                      <v-card-text>
                        <div class="text--primary">
                          กรณีขอตวามช่วยเหลือท่านมีความประสงค์ให้ทางบริษัทช่วยเหลือท่านเรื่องใดบ้าง
                        </div>
                      </v-card-text>
                      <v-card-text>
                        <center>
                          <v-card>
                      <v-container fluid>
                        <v-checkbox
                          v-model="selected1"
                          label="อาหาร/น้ำดื่ม"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="selected2"
                          label="ยาสามัญ"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="selected3"
                          label="ที่พักเฝ้าสำหรับกักตัว"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="selected4"
                          label="เครื่องวัดอ็อกซิเจน"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="selected5"
                          label="หน้ากากอนามัย"
                        ></v-checkbox>
                      </v-container>
                      </v-card>
                      <br>

                      <v-row style="height: 35px">
                      <v-subheader id="subtext" class="text--primary">อื่นๆ</v-subheader>
                      </v-row>
                      <v-row style="height: 50px">
                        <v-col cols="12" >
                      <v-text-field
                      v-model="selectedOther"
                        placeholder="กรอกสำหรับอื่นๆที่ต้องการ"
                        required
                      ></v-text-field>
                      </v-col>
                      </v-row>
                      <br>
                        </center>
                      </v-card-text>
                    </v-card>
                  </v-card-text>
                </v-card-text>
                <center>
                  <v-btn color="blue" block dark large  @click="approve()" v-if="e1==2"> ยืนยัน </v-btn>
                 </center>
                </template>

          </v-col>
        </v-row>
      </v-container>
       </center>
  </div>
</template>
<script>
import { gmapApi } from 'vue2-google-maps'
import axios from 'axios'
// import VuetifyLogo from '../logo'
export default {
  components: {
    gmapApi
  },
  name: 'Info',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      e1: 1,
      center: {},
      profile: [],
      checkItem: [],
      shifttem: [],
      selection: 1,
      covidField: '',
      covidPeopleNum: '',
      selected1: false,
      selected2: false,
      selected3: false,
      selected4: false,
      selected5: false,
      selectedOther: '',
      files: null,
      form: {
        userLineuserId: '',
        userLinepictureUrl: ''
      },
      hideInfo: true,
      dataReady: true,
      hideCheckinHistory: false,
      AccessKey: '',
      ApplicationKey: '',
      imageHeadHRM: '',
      imageUrlBack: '',
      numberRules: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 999) ||
          'กรุณา กรอกเป็นตัวเลข 0-9'
      ]
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.dataReady = false
    console.log('get_profile')
    await this.geolocate()
    await this.checkLiffLogin()
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    geolocate () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.dataReady = true
          console.log('center : ', center)
          this.center = center
        },
        (error) => {
          console.log('error map :', error.message)
          alert('กรุณาเปิด location ของท่าน')
        }
      )
    },
    async checkLiffLogin () {
      await this.$liff.ready.then(async () => {
        if (process.env.NODE_ENV === 'development') {
          this.getProfile_dev()
        } else {
          if (!this.$liff.isLoggedIn()) {
            this.$liff.login({ redirectUri: window.location })
          } else {
            await this.getProfile()
          }
        }
      })
    },
    async getProfile () {
      let _this = this
      await this.$liff
        .getProfile()
        .then(async (profileLine) => {
          _this.form.userLineuserId = profileLine.userId
          _this.form.userLinepictureUrl = profileLine.pictureUrl
          await _this.getDataEmp(_this.form)
        })
        .catch(function (error) {
          alert('Error getting profile: ' + error)
        })
    },
    async getProfile_dev () {
      let _this = this
      _this.form.userLineuserId = _this.main_profile.userLineuserId
      _this.form.userLinepictureUrl = _this.main_profile.pictureUrl
      await _this.getDataEmp(_this.form)
    },
    async getDataEmp (dt) {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/lineid?userLineuserId=' +
            dt.userLineuserId
        )
        .then(async (response) => {
          if (response.data[0].empCode) {
            this.profile = response.data[0]
            //
          } else {
            this.$swal('ไม่พบรหัสพนักงาน', 'คุณไม่มีสิทธิ์เข้าใช้ระบบ กรุณาติดต่อฝ่ายบุคคล', 'error')
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.$router.push('/Liff/LoginRisk')
        })
    },
    accept () {
      this.e1 = 2
    },
    approve () {
      console.log('center', this.center)
      console.log('profile', this.profile)
      let ds = {
        empCode: this.profile.empCode,
        selection: this.selection,
        covidField: this.covidField,
        covidPeopleNum: this.covidPeopleNum,
        selected1: this.selected1,
        selected2: this.selected2,
        selected3: this.selected3,
        selected4: this.selected4,
        selected5: this.selected5,
        selectedOther: this.selectedOther
      }
      this.addData(ds)
    },
    async addData (ds) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/covid_register/add", ds
        )
        .then(async (response) => {
          console.log(response)
          this.$router.push('/Liff/RegisterCovidShow')
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async fileupload () {
      const _this = this
      let params = new FormData()
      _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.files)

      await axios
        .post(this.DNS_IP + '/covid_register/upload', params)
        .then(function (response) {
          _this.covidField = _this.DNS_IP + '/' + response.data
        })
    }

  }
}
</script>
<style scoped>
.table-header {
    background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/RegisterCovid.vue